(() => {
  'use strict';
  if (customElements.get('category-261010-hero')) return;

  class CategoryHero extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-dh-scroll-target]');
        if (!link || !this.contains(link)) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.dataset.dhScrollTarget);
        if (!target) return;
        event.preventDefault();
        const offset = Math.max(0, Number(this.dataset.scrollOffset) || 0);
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
        const url = new URL(window.location.href);
        url.hash = link.dataset.dhScrollTarget;
        window.history.replaceState(window.history.state, '', url);
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('category-261010-hero', CategoryHero);
})();
